export default "__VITE_ASSET__jEc$ULLd__"